import React from "react";
import type { TOrganizer } from "components/organizer/helpers/organizer-types-helper";
import Icons from "components/icons";
import { Localize } from "components/service";
import EmailChannelFields from "../fields";
import groupEmailChannels from "./email-channel-group-helper";
import type {
  TEmailChannel,
  TEmailChannelTableRow,
} from "./email-channel-types-helper";

const EmailChannelTableHelper = (onOpenGuide: () => void) => ({
  columns: [
    {
      title: <Localize>EMAIL_CHANNEL.Column_Email</Localize>,
      dataIndex: "email",
      width: "50%",
    },
    {
      title: (
        <span className="email-channel-column-title">
          <Localize>EMAIL_CHANNEL.Column_Status</Localize>
          <button type="button" onClick={onOpenGuide}>
            <Icons.Question />
          </button>
        </span>
      ),
      dataIndex: "status",
      width: "20%",
    },
    {
      title: (
        <span className="email-channel-column-title">
          <Localize>EMAIL_CHANNEL.Column_Visibility</Localize>
          <button type="button" onClick={onOpenGuide}>
            <Icons.Question />
          </button>
        </span>
      ),
      dataIndex: "visibility",
      width: "20%",
    },
    {
      dataIndex: "action",
      align: "right" as const,
      width: "10%",
    },
  ],
  data: (
    channels: TEmailChannel[] = [],
    organizer: TOrganizer,
    variables: Record<string, any>
  ): TEmailChannelTableRow[] =>
    groupEmailChannels(channels, organizer?.exhibitionTypes ?? []).map(
      (group) => ({
        key: group.key,
        rowType: "group",
        email: <strong className="email-channel-group-title">{group.title}</strong>,
        action: (
          <span className="email-channel-group-summary">
            {group.total} <Localize>EMAIL_CHANNEL.Group_Emails</Localize> | {" "}
            {group.active} <Localize>EMAIL_CHANNEL.Group_Active</Localize>
          </span>
        ),
        children: group.channels.map((channel) => ({
          key: `email-channel-${channel.id}`,
          rowType: "channel",
          email: <EmailChannelFields.Info channel={channel} />,
          status: (
            <EmailChannelFields.Status channel={channel} variables={variables} />
          ),
          visibility: (
            <EmailChannelFields.Visibility
              channel={channel}
              variables={variables}
            />
          ),
          action: (
            <EmailChannelFields.Action
              organizer={organizer}
              channel={channel}
              variables={variables}
            />
          ),
        })),
      })
    ),
});

export default EmailChannelTableHelper;
